var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#F5CD47"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0002 28.7528C40.9726 28.7528 41.9398 29.3664 42.6764 30.5936L52.9239 47.6739C54.399 50.1265 53.2602 52.1337 50.4002 52.1337H29.6002C26.7402 52.1337 25.6014 50.1248 27.0764 47.6739L37.3239 30.5936C38.0606 29.3664 39.0278 28.7528 40.0002 28.7528ZM40.0002 25.2861C37.7538 25.2861 35.698 26.5688 34.3512 28.8065L24.1038 45.8903C22.7414 48.1592 22.5923 50.5789 23.6964 52.5289C24.8006 54.4789 26.9534 55.6004 29.6002 55.6004H50.4002C53.047 55.6004 55.2015 54.4807 56.3039 52.5307C57.4063 50.5807 57.259 48.1609 55.8966 45.892L45.6491 28.8117C44.3023 26.5688 42.2466 25.2861 40.0002 25.2861Z",
    fill: "#533F04"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0004 49.1873C41.2449 49.1873 42.2537 48.1785 42.2537 46.934C42.2537 45.6895 41.2449 44.6807 40.0004 44.6807C38.7559 44.6807 37.7471 45.6895 37.7471 46.934C37.7471 48.1785 38.7559 49.1873 40.0004 49.1873Z",
    fill: "#533F04"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6003 36.5336C42.6003 35.0949 41.4372 33.9336 40.0003 33.9336C39.5749 33.9341 39.1561 34.039 38.7807 34.239C38.4052 34.4391 38.0846 34.7282 37.8469 35.081C37.6093 35.4338 37.4618 35.8396 37.4175 36.2627C37.3731 36.6858 37.4333 37.1133 37.5927 37.5077C38.553 39.8928 40.0003 43.4669 40.0003 43.4669L42.4114 37.5077C42.5292 37.2079 42.6003 36.8785 42.6003 36.5336Z",
    fill: "#533F04"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningicon);
export default __webpack_public_path__ + "static/media/warningicon.914ec80fe500d6277f638efa80ae5d85.svg";
export { ForwardRef as ReactComponent };